/* Diamond Feed — orchestrator + grid view.
   Owns all state for the feed: filters, sort, pagination, the Grid⇄Table
   toggle, the filter drawer, the toolbar and the quick-view drawer. Renders
   grid cards itself and delegates table rendering to DiamondFeedTableView. */
(function () {
  'use strict';
  var DF = window.DiamondFeed;
  if (!DF) return;
  DF.init();

  var root = document.getElementById('diamondFeed');
  if (!root) return;
  var CFG = DF.config || {};
  var LIMIT = parseInt(root.getAttribute('data-page-size'), 10) || 24;

  // ---- State ----
  var state = DF.defaultState();
  state.sort = 'featured';
  var accItems = [];      // accumulated stones across pages
  var total = null;       // grand total (fetched separately; null = still loading)
  var hasMore = false;    // more pages likely exist (used until total is known)
  var nextCursor = null;  // proxy-issued cursor for the next page (per-origin offsets)
  var page = 0;
  var openId = null;      // table: currently expanded stone
  var loading = true;     // first paint shows the loading state
  var errored = false;
  // Base default comes from the section (data-view, set by the "Default view"
  // setting); a shopper's remembered choice and an explicit ?view= link override it.
  var view = root.getAttribute('data-view') === 'table' ? 'table' : 'grid';
  try { var v = localStorage.getItem('shannon-diamond-view'); if (v === 'table' || v === 'grid') view = v; } catch (e) {}

  // Deep links (?shape=oval, ?type=lab, ?view=table, …) — applied before the
  // first fetch; an explicit URL view overrides the remembered one.
  var urlInit = DF.applyURLParams(state);
  if (urlInit.view) view = urlInit.view;

  // ---- DOM ----
  var grid       = document.getElementById('grid');
  var gridWrap   = document.getElementById('gridWrap');
  var tableMain  = document.getElementById('tableMain');
  var tbody      = document.getElementById('tbody');
  var theadRow   = document.getElementById('theadRow');
  var feedEmpty  = document.getElementById('feedEmpty');
  var countNum   = document.getElementById('countNum');
  var statTotal  = document.getElementById('statTotal');
  var seenCount  = document.getElementById('seenCount');
  var badge      = document.getElementById('filtersBadge');
  var activeWrap = document.getElementById('activeFilters');
  var sortSel    = document.getElementById('sortSel');
  var loadMore   = document.getElementById('loadMore');
  var loadCount  = document.getElementById('loadCount');
  var loadBar    = document.getElementById('loadBar');
  var loadMoreWrap = document.getElementById('loadMoreWrap');
  var loadMoreT  = document.getElementById('loadMoreTable');
  var loadCountT = document.getElementById('loadCountTable');
  var tableFoot  = document.getElementById('tableFoot');

  var dash = function (v) { return (v == null || v === '') ? '—' : v; };
  var qv = DF.quickView();

  // ---- Filters: persistent left rail on desktop, slide-in drawer on mobile ----
  // The controls are built once into a detached host, then moved between the rail
  // (#railControls) and the drawer body (#filterControls) on breakpoint changes.
  // Moving the node preserves its event listeners, so there's a single source of
  // truth and no duplicate wiring.
  var drawer = document.getElementById('filterDrawer');
  var filtersHost = document.createElement('div');
  filtersHost.className = 'filter-controls';
  var filterCtl = DF.buildFilters(filtersHost, state, onFilterChange);
  var railHost = document.getElementById('railControls');
  var drawerHost = document.getElementById('filterControls');
  var railMQ = window.matchMedia('(min-width: 861px)');
  function placeFilters() {
    var target = (railHost && railMQ.matches) ? railHost : drawerHost;
    if (target && filtersHost.parentNode !== target) target.appendChild(filtersHost);
  }
  placeFilters();
  if (railMQ.addEventListener) railMQ.addEventListener('change', placeFilters);
  else if (railMQ.addListener) railMQ.addListener(placeFilters);
  if (urlInit.applied) filterCtl.sync();   // reflect URL-applied filters in the controls
  document.getElementById('filtersBtn').addEventListener('click', openDrawer);
  drawer.addEventListener('click', function (e) { if (e.target.closest('[data-drawer-close]')) closeDrawer(); });
  document.getElementById('drawerApply').addEventListener('click', closeDrawer);
  document.getElementById('drawerClear').addEventListener('click', clearAll);
  function openDrawer() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeDrawer() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }

  function onFilterChange() { reload(); }
  function clearAll() {
    var d = DF.defaultState();
    Object.keys(d).forEach(function (k) { state[k] = d[k]; });
    state.shapes = new Set();
    state.sort = sortSel ? sortSel.value : 'featured';
    filterCtl.sync();
    reload();
  }

  // ---- Sort: dropdown + clickable table columns share state.sort ----
  if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; reload(); });
  if (theadRow) theadRow.addEventListener('click', function (e) {
    var th = e.target.closest('th'); if (!th || th.classList.contains('no-sort')) return;
    var field = th.getAttribute('data-sort'); if (!field) return;
    var cur = state.sort || '';
    var isAsc = cur === field + '-asc';
    state.sort = isAsc ? field + '-desc' : field + '-asc';
    reload();
  });

  // ---- View toggle ----
  root.querySelectorAll('[data-view-btn]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      setView(btn.getAttribute('data-view-btn'));
    });
  });
  function setView(v) {
    view = v;
    try { localStorage.setItem('shannon-diamond-view', v); } catch (e) {}
    root.setAttribute('data-view', v);
    root.querySelectorAll('[data-view-btn]').forEach(function (b) {
      var on = b.getAttribute('data-view-btn') === v;
      b.classList.toggle('is-on', on);
      if (on) b.setAttribute('aria-current', 'page'); else b.removeAttribute('aria-current');
    });
    render();
  }

  // ---- Load more ----
  [loadMore, loadMoreT].forEach(function (b) { if (b) b.addEventListener('click', loadMoreFn); });
  function loadMoreFn() {
    if (loading || !hasMore) return;
    if (total != null && accItems.length >= total) return;
    page += 1; fetchPage(false);
  }

  // ---- Active filter chips ----
  function buildChips() {
    var chips = DF.describeChips(state);
    activeWrap.innerHTML = '';
    if (!chips.length) return;
    chips.forEach(function (c) {
      var el = document.createElement('span');
      el.className = 'afilter';
      el.innerHTML = '<span></span>';
      el.firstChild.textContent = c[1];
      var btn = document.createElement('button');
      btn.type = 'button'; btn.setAttribute('aria-label', 'Remove ' + c[1]); btn.textContent = '×';
      btn.addEventListener('click', function () { c[2](); filterCtl.sync(); reload(); });
      el.appendChild(btn);
      activeWrap.appendChild(el);
    });
    var clear = document.createElement('button');
    clear.className = 'active-filters__clear'; clear.type = 'button'; clear.textContent = 'Clear all';
    clear.addEventListener('click', clearAll);
    activeWrap.appendChild(clear);
  }

  // ---- Grid card ----
  var gridMedia = grid.getAttribute('data-media') === 'video' ? 'video' : 'image';
  function card(s) {
    var perCt = grid.getAttribute('data-price') === 'percarat';
    var price = (perCt && s.price != null && s.carat)
      ? DF.fmtUSD(s.price / s.carat) + '<span class="per">/ct</span>'
      : DF.fmtUSD(s.price);
    var mediaInner = DF.mediaHTML(s, gridMedia);
    var el = document.createElement('button');
    el.className = 'dcard'; el.type = 'button';
    el.innerHTML =
      '<div class="dcard__media">' +
        '<span class="dcard__origin' + (s.type === 'lab' ? ' is-lab' : '') + '">' + (s.type === 'lab' ? 'Lab-Grown' : 'Natural') + '</span>' +
        mediaInner +
        '<span class="dcard__view">Quick view</span>' +
      '</div>' +
      '<div class="dcard__row">' +
        '<span class="dcard__name">' + DF.fmtCt(s.carat) + ' ct ' + DF.shapeLabel(s) + '</span>' +
        '<span class="dcard__price">' + price + '</span>' +
      '</div>' +
      '<div class="dcard__cs">' + dash(s.color) + ' · ' + dash(s.clarity) + ' · ' + DF.cutLabel(s) + (s.lab ? ' · ' + s.lab : '') + '</div>';
    el.addEventListener('click', function () { qv.open(s); });
    return el;
  }

  function renderGrid() {
    grid.innerHTML = '';
    var frag = document.createDocumentFragment();
    accItems.forEach(function (s) { frag.appendChild(card(s)); });
    grid.appendChild(frag);
    // Scale any 360° card viewers (when card media = video) to their box.
    if (gridMedia === 'video' && DF.fit360) DF.fit360(grid);
  }

  // ---- Render ----
  function render() {
    root.setAttribute('data-view', view);
    root.querySelectorAll('[data-view-btn]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-view-btn') === view);
    });

    var countTxt = total == null ? '…' : total.toLocaleString('en-US');
    if (countNum) countNum.textContent = countTxt;
    if (statTotal) statTotal.textContent = countTxt;
    if (seenCount) seenCount.textContent = countTxt;
    var n = DF.countActive(state);
    badge.textContent = n; badge.hidden = n === 0;
    buildChips();
    if (sortSel) sortSel.value = state.sort;
    if (theadRow) DiamondFeedTableView.paintSort(theadRow, state.sort);

    var hasItems = accItems.length > 0;
    var showGrid = view === 'grid';
    gridWrap.hidden = !showGrid || !hasItems;
    tableMain.hidden = showGrid || !hasItems;

    // Loading / empty / error state (no items yet)
    if (!hasItems) {
      feedEmpty.hidden = false;
      feedEmpty.innerHTML = '';
      if (loading) {
        feedEmpty.innerHTML = '<h3 class="serif">Finding diamonds…</h3><p>Loading the latest stones from our partners.</p>';
      } else if (errored) {
        feedEmpty.innerHTML = '<h3 class="serif">We couldn’t load the feed.</h3><p>Please check your connection and try again.</p>';
        var retry = document.createElement('button'); retry.type = 'button'; retry.textContent = 'Try again';
        retry.addEventListener('click', reload); feedEmpty.appendChild(retry);
      } else {
        feedEmpty.innerHTML = '<h3 class="serif">No diamonds match just yet.</h3><p>Try widening your carat or price range, or clearing a filter.</p>';
        var b = document.createElement('button'); b.type = 'button'; b.textContent = 'Clear all filters';
        b.addEventListener('click', clearAll); feedEmpty.appendChild(b);
      }
      return;
    }
    feedEmpty.hidden = true;

    if (showGrid) renderGrid();
    else DiamondFeedTableView.render(tbody, accItems, {
      openId: openId,
      onToggle: function (id) { openId = id; render(); },
      onAdd: addToRing
    });

    // Load-more (per active view). The proxy's has_more is authoritative; the
    // count-based check catches the final exactly-full page early.
    var done = !hasMore || (total != null && accItems.length >= total);
    var shown = accItems.length.toLocaleString('en-US');
    var showText = total != null ? 'Showing ' + shown + ' of ' + total.toLocaleString('en-US') : 'Showing ' + shown;
    if (showGrid) {
      if (loadMoreWrap) loadMoreWrap.style.display = '';
      if (loadMore) loadMore.hidden = done;
      if (loadCount) loadCount.textContent = showText;
      if (loadBar) loadBar.style.width = (total ? Math.round(accItems.length / total * 100) : 0) + '%';
    } else {
      if (tableFoot) tableFoot.style.display = '';
      if (loadMoreT) loadMoreT.hidden = done;
      if (loadCountT) loadCountT.textContent = showText + ' diamonds';
    }
  }

  // ---- Add to ring (real Shopify cart via proxy /reserve + /cart/add.js) ----
  function addToRing(s, btn) {
    if (typeof CFG.onAdd === 'function') return CFG.onAdd(s, btn);
  }

  // ---- Fetch (items and total are independent requests) ----
  function reload() {
    page = 0; openId = null; accItems = []; total = null; hasMore = false; nextCursor = null;
    fetchPage(true);   // items (fast)
    fetchTotal();      // count (slower, fills in)
  }
  // One automatic retry on failure (a cold proxy path or a stalled connection
  // is usually fine the second time); after that the shopper gets an explicit
  // "Try again" instead of an endless "Finding diamonds…". reqSeq makes a
  // pending retry stand down if a newer request (filter change) has started.
  var reqSeq = 0;
  function fetchPage(reset, attempt) {
    attempt = attempt || 0;
    var seq = ++reqSeq;
    loading = true; errored = false;
    root.setAttribute('data-loading', 'true');
    if (reset) render();   // show the loading state immediately
    DF.fetchFeed(state, page, LIMIT, reset ? null : nextCursor).then(function (j) {
      if (seq !== reqSeq) return;   // superseded
      loading = false;
      root.removeAttribute('data-loading');
      var batch = j.items || [];
      accItems = reset ? batch : accItems.concat(batch);
      nextCursor = j.next_cursor || null;
      hasMore = typeof j.has_more === 'boolean' ? j.has_more : batch.length >= LIMIT;
      render();
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;   // a newer request took over
      if (seq !== reqSeq) return;
      if (attempt < 1) {
        setTimeout(function () { if (seq === reqSeq) fetchPage(reset, attempt + 1); }, 1200);
        return;
      }
      loading = false; errored = true;
      root.removeAttribute('data-loading');
      if (reset) accItems = [];
      render();
    });
  }
  function fetchTotal() {
    DF.fetchCount(state).then(function (j) {
      if (j && typeof j.total_count === 'number') total = j.total_count;
      render();
    }).catch(function (err) { if (!err || err.name !== 'AbortError') render(); });
  }

  // Build-your-ring flow: cache status for the CTA labels and surface the
  // "your setting is in the bag" strip when a setting awaits its stone.
  if (window.ShannonRingFlow) {
    ShannonRingFlow.flowStatus().then(function (fs) { window.__shannonFlow = fs; }).catch(function () {});
    ShannonRingFlow.mountFlowStrip('#diamondFeed .feed-toolbar', 'needs-diamond');
  }

  setView(view);   // paints the toggle, then…
  reload();        // first load
})();
